import { useNavigate } from "react-router-dom";
import styled from "styled-components";

export default function MayoHelp() {
  const navigate = useNavigate();

  return (
    <Container>
      <Title>
        How may we help you?
      </Title>
      <Text style={{marginBottom: 16}}>
        Medical care away from home can be uncertain and filled with questions. Our concierge service team is here to help you.
      </Text>

      <SubContainer>
        <Section>
          <SubTitle>
            Location |
          </SubTitle>
          <Text>
            Mayo Building, Lobby Level, inside the international center.
          </Text>
        </Section>

        <Section>
          <SubTitle>
            Hours |
          </SubTitle>
          <Text>Available in person:</Text>
          <Text>8:00 AM to 6:00 pm, Monday-Friday.</Text>
          <Text>Available by phone and email:</Text>
          <Text>7:00 AM to 6:00 pm, Monday-Friday.</Text>
        </Section>

        <Section>
          <SubTitle>
            Transportation |
          </SubTitle>
          <Text>
            <LinkText onClick={() => navigate("/patient/mayo/shuttle")}
            >Click here
            </LinkText> for our patient shuttle service schedule.
          </Text>
        </Section>
      </SubContainer>
    </Container>
  );
}

const Container = styled.div`
  margin-left: 26px;
  margin-right: 35px;
  margin-block: 36px;
`

const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const Section = styled.div`
`

const Title = styled.p`
  margin: 0;
  font-size: 24px;
  font-weight: 600; 

  margin-bottom: 22px;
`

const SubTitle = styled.p`
  margin: 0;
  font-size: 19px;
  font-weight: 600;
`

const Text = styled.p`
  margin: 0;
  font-size: 19px;
`

const LinkText = styled.span`
  text-decoration: underline;
  color: #81A0F6;
  font-size: 19px;
`